import styled from "styled-components";

export const Div = styled.div`
	.dis-area-container {
		width: 100%;
	}
	.checkbox-container {
		display: flex;
		align-items: center;
	}
	.description {
		width: 100%;
	}
	.checkbox-container label {
		margin-right: 10px;
	}
	.services {
		display: inline-flex;
		margin: 16px 0 16px 10px;
	}
	.products {
		display: inline-flex;
		margin: 16px 0 16px 0px;
	}
	.level {
		display: flex;
	}
	.select-comp {
		display: flex;
		border-bottom: 1px solid rgb(223 223 223);
		width: 100%;
		padding-bottom: 16px;
	}
	.check-box {
		margin: auto 2px;
		&:first-child {
			margin: 0 2px 0 0;
		}
		display: flex;
		padding: 12px;
		gap: 10px;
	}
	.check-container {
		margin: auto 2px;
	}
	.p-service {
		font-weight: 400;
		font-size: 0.9375rem;
		line-height: 24px;
		color: #637381;
	}

	.check-box-lable{
		color: #637381;
		font-weight: 400;
	}

	@media (max-width: 640px) {
		.p-service {
		margin-left: 7px;
	}
	}

	@media (min-width: 1080px) {
		.select-comp {
			display: flex;
		}
	}

	@media (min-width: 769px) and (max-width: 1080px) {
		.select-comp {
			display: flex;
		}
	}

	@media (max-width: 1000px) {
		.select-comp {
			display: flex;
			flex-wrap: wrap;
		}
	}
`;

export const Retangle = styled.div`
	width: 10px;
	height: 6px;
	padding-right: 0px 3px;
	background-color: #2c76aa;
	margin: auto 2px;
`;

export const WhiteRetangle = styled.div`
	width: 10px;
	height: 6px;
	padding-right: 0px 3px;
	background-color: #eaeaea;
	margin: auto 2px;
`;

export const CheckBox = styled.input`
	appearance: none;
	-webkit-appearance: none;
	-moz-appearance: none;

	width: 14px;
	height: 14px;
	border: 1px solid #0971A2;
	border-radius: 50%;
	display: inline-block;
	position: relative;
	cursor: pointer;

	&:checked {
		/* background-color: #0971A2; */
		border-color: #0971A2;
	}

	&:checked::before {
		content: "";
		width: 8px;
		height: 8px;
		/* border: 1px solid #0971A2; */
		background-color: #0971A2;
		border-radius: 50%;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	&:first-child {
		margin: 4px 1px;
	}
`;

export const Label = styled.label`
	padding: 0 2px;
	font-weight: 700;
	line-height: 24px;
	color: #333333;
`;
